const moo = require('moo');

module.exports = moo.compile({
    comparator: ['>', '<', 'before', 'after'],
    year: /[1-2]\d{3}/,
    month_name: ['january','february','march','april','may','june','july','august','september','october','november','december','jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'],
    day_name: ['sun', 'mon', 'tues', 'wed',  'thurs', 'fri', 'sat'],
    digit_2: /\d{1,2}/,
    meridian: ['am','pm'],
    ordinal: ['st', 'nd', 'rd', 'th'],
    at: ['at', '@'],
    wschar: {match:/\s/, lineBreaks: true},
    range: ['-', 'to'],
    x: ['.','/'],
    comma: [','],
    st: [':']
})


// WEBPACK FOOTER //
// ./project/services/date-parser/date-lexer.js